<template>
  <v-menu
    offset-y
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        style="margin:0px 10px"
        text
        small
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        初始化数据导入
      </v-btn>
    </template>

    <v-list>
      <v-list-item
       
        link
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-btn
              text
              @click="click"
            >
              下载模版
            </v-btn>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
       
        link
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-btn
              text
              @click="upload"
            >
              导入
            </v-btn>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div
      ref="contain"
      style="display: none"
    />
  </v-menu>
</template>
<script>
  import {pay_manage_http as http } from '@/libs/util.js'
  import { getDownloadCustomerMonthSalaryTotalDownInitTemplateFileApi, customer_month_salary_total_import_init_data } from '@/views/fin/salaryadministration/service.js'
  export default {
    props: {
      id: {
        type: [Number, String]
      },
      btns: {
        type: Array,
        default:() => [] 
      },
      other: {
        type: Object,
        default: () => ({})
      },
      target: {
        type: Object,
        default: () => ({}) 
      }
    },
    methods: {
      click() {
        const str = getDownloadCustomerMonthSalaryTotalDownInitTemplateFileApi()
        window.open(str, '__blank')
      },
      upload() {
        this.el = document.createElement('input')
        this.el.setAttribute('type', 'file')
        this.$refs.contain.appendChild(this.el)
        this.el.click()
        this.el.addEventListener('change', this.uploadFile)
      },
      uploadFile() {
        const file = this.el.files[0]
        const format = ['xlsx', 'csv']
        const arr = (format || []).map(item => new RegExp(item + '$'))
        if (arr.some(item => (item.test(file.type) || item.test(file.name)))) {
          if (file.name.indexOf('%') > -1) {
            this.$Modal.error({
              title: '提示',
              content: '文件名不能包含百分号%'
            });
            return
          }
        
          this.uploading = true
          const formData = new FormData();
          formData.append('file', file)
          formData.append('id', this.id)
          // placing_ads_record_import
          http.post_upload(customer_month_salary_total_import_init_data, { formData }).then((res) => {
           
         
            this.$emit('uploaded', res.file);
        
          }).finally(() => {
        
            this.uploading = false
          })
        } else {
          this.$Modal.error({
            title: '提示',
            content: `请上传${format.join('、')}格式文件`
          })
        }
        this.el.removeEventListener('change', this.uploadFile)
        const childrenInputs = this.$refs.contain.childNodes
        for (let i = 0, len = childrenInputs.length; i < len; i++) {
          if (childrenInputs[i] instanceof HTMLElement) {
            this.$refs.contain.removeChild(childrenInputs[i])      
          }
      
        }
        this.el = null
      },
    }
  }
</script>